import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {TimeTableSortKey, TimeTableBmFilterKey} from '../type';

export interface IStateTimeTable {
  sortKeyByDayTab: TimeTableSortKey;
  bmFilterKey: TimeTableBmFilterKey;
}

const INITIAL_STATE: IStateTimeTable = {
  sortKeyByDayTab: 'recommend',
  bmFilterKey: 'freePublishing',
};

export default createReducer<
  IStateTimeTable,
  ReducerActionHelper<typeof actions>
>(INITIAL_STATE, {
  ...createBasicReducerHandlers({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
});
